var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('GFMP',{attrs:{"styles":{ ..._vm.fmpStyles.rounded, width: '80px' }}}),_vm._l((_vm.listCount),function(i){return _c('ProductInlineLoader',{key:i})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }